import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import styled from 'styled-components';
import Flex from '../atoms/Flex';
import Container from '../atoms/Container';
import CurrentUser from '../molecules/user/CurrentUser';
// @ts-ignore
import { getLogoForTheme } from '../../services/appTheme';
import { Link, usePage } from '@inertiajs/react';
import MenuToggle from '../atoms/MenuToggle';
const StyledTopBar = styled.div `
    position: fixed;
    background-color: #ffffff;
    box-shadow: 0 0 3px 2px rgba(0, 0, 0, 0.11);
    padding: 10px 0;
    width: 100%;
    z-index: 6;
`;
const StyledLogo = styled.img `
    width: 120px;
    height: 54px;
    object-fit: contain;
    object-position: left center;

    @media only screen and (min-width: 992px) {
        width: 190px;
        height: 54px;
    }
`;
const TopBarPush = styled.div `
    height: 78px;
    min-height: 78px;
`;
const TopBar = ({ onClick, toggleIcon }) => {
    const page = usePage();
    return (_jsxs(_Fragment, { children: [_jsx(StyledTopBar, { "data-testid": "topbar", children: _jsx(Container, { children: _jsxs(Flex, { fullWidth: true, justifyContent: "space-between", alignItems: "center", children: [_jsx(Link, { href: "/", children: _jsx(StyledLogo, { src: getLogoForTheme(page.props.domain) }) }), _jsx(Flex, { margin: "0 0 0 auto", children: _jsx(CurrentUser, { userName: page.props.auth.user?.name }) }), _jsx(MenuToggle, { onClick: onClick, toggleIcon: toggleIcon, "aria-label": "Menu" })] }) }) }), _jsx(TopBarPush, {})] }));
};
export default TopBar;
